import { AgGridReactProps } from '@ag-grid-community/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ContentBlock from '../../../../../../components/Layout/ContentBlock';
import NoDataContainer from '../../../../../../components/NoDataContainer';
import TableGrid, { MainColumns } from '../../../../../../components/TableGrid';

export interface DetailsDataTableProps extends AgGridReactProps {
  data?: unknown[];
  title: string;
  translationsScope: string;
  columns: MainColumns[];
  actions?: React.ReactNode;
}

const DetailsDataTable: React.FC<DetailsDataTableProps> = ({
  data,
  columns,
  title,
  translationsScope,
  actions,
  ...restProps
}) => {
  const { t } = useTranslation();

  return (
    <ContentBlock title={t(`${translationsScope}:${title}`)} actions={actions}>
      {data && data?.length ? (
        <TableGrid
          columns={columns}
          translationKey={translationsScope}
          originalProps={{
            rowData: data,
            rowModelType: 'clientSide',
            domLayout: 'autoHeight',
            ...restProps,
          }}
        />
      ) : (
        <NoDataContainer />
      )}
    </ContentBlock>
  );
};

export default DetailsDataTable;
